import { useState } from 'react';
import { useReadersStore } from '@/store/readers.store';
import { useRewardsStore } from '@/store/rewards.store';
import { rewardsService } from '@/services/rewards.service';

export function useHatchEgg() {
  const [hatching, setHatching] = useState(false);
  const selectedReader = useReadersStore((s) => s.selectedReader());
  const removeEgg = useRewardsStore((s) => s.removeEgg);
  const setRevealResult = useRewardsStore((s) => s.setRevealResult);
  const setHatchingEggId = useRewardsStore((s) => s.setHatchingEggId);

  async function hatch(eggId: string) {
    if (!selectedReader || hatching) return;
    setHatching(true);
    setHatchingEggId(eggId);

    try {
      const result = await rewardsService.hatchEgg(selectedReader.id, eggId);
      removeEgg(eggId);
      setRevealResult(result);
    } catch (err) {
      console.error('[useHatchEgg] Failed to hatch:', err);
      setHatchingEggId(null);
    } finally {
      setHatching(false);
    }
  }

  return { hatch, hatching };
}
